import type * as React from "react";
import { useState } from "react";
import { MaterialInput, type MaterialInputProps } from "./MaterialInput";
import { makeStyles } from "@mui/styles";
import { Icon } from "../icon/Icon";
import { type IconType } from "../icon/IconType";
import { C_PRIMARY, C_PRIMARY_DISABLED } from "../icon/Colors";
import { FONT_RAW_SIZES, FontSize } from "./Fonts";
import classNames from "classnames";

// TODO: Label should be a react node?
type PickedProps =
  | "label"
  | "helperLabel"
  | "shrink"
  | "value"
  | "placeholder"
  | "error"
  | "colorHelperOnError"
  | "inputRef";
type PropsFromInput = Pick<MaterialInputProps, PickedProps>;
export interface ClickableMaterialInputProps extends PropsFromInput {
  disabled?: boolean;
  isHighlight?: boolean;
  iconType: IconType;
  iconTypeAfterClick: IconType;
  value?: string;
  onChange?: (e?: any) => void;
  name?: string;
  onBlur?: () => void;
  autoComplete?: string;
}

const useStyles = makeStyles({
  wrapper: {
    position: "relative",
    "& input": {
      cursor: "auto",
    },
    width: "100%",
  },
  icon: {
    lineHeight: FONT_RAW_SIZES[FontSize.BodyMedium].lineHeight + "px",
    color: C_PRIMARY,
    cursor: "pointer",

    "&.disabled": {
      color: C_PRIMARY_DISABLED,
      cursor: "default",
    },
  },
  iconNoLabel: {
    top: "8px",
  },
});

export const PasswordInput: React.FC<ClickableMaterialInputProps> = (props) => {
  const { iconType, iconTypeAfterClick, value, onChange, inputRef, name, ...inputProps } = props;
  const classes = useStyles();

  const [iconClicked, setIconClicked] = useState<boolean>(false);

  const onEyeClick = () => setIconClicked((prev) => !prev);

  return (
    <div className={classes.wrapper}>
      <MaterialInput
        value={value}
        onChange={onChange}
        name={name}
        inputRef={inputRef}
        type={iconClicked ? "text" : "password"}
        endAdornment={
          <span onClick={inputProps.disabled ? undefined : onEyeClick}>
            <Icon
              type={iconClicked ? iconTypeAfterClick : iconType}
              className={classNames(
                classes.icon,
                inputProps.disabled && "disabled",
                !inputProps.label && classes.iconNoLabel,
              )}
            />
          </span>
        }
        {...inputProps}
      />
    </div>
  );
};

export default PasswordInput;
